import httpClient from './httpClient'

export default {
  async getAllLiveStreamKey() {
    let ret = await httpClient.get('live_stream_key')
    return ret
  },
  async getSingleLiveStreamKey({ id }) {
    let ret = await httpClient.get(`live_stream_key/${id}`)
    return ret
  },
  async createLiveStreamKey(data) {
    let ret = await httpClient.post('live_stream_key', data)
    return ret
  },
  async saveLiveStreamKey({ id, data }) {
    let ret = await httpClient.put(`live_stream_key/${id}`, data)
    return ret
  },
  async deleteLiveStreamKey({ id }) {
    let ret = await httpClient.delete(`live_stream_key/${id}`)
    return ret
  },
}
